import { useRecoilState } from "recoil";
import { locationsState, memberState } from "../state/atoms";
import "./LocationDropdown.scss";
import { Button, Dropdown, Input } from "antd";
import { DownOutlined, SearchOutlined, UserOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import ChangeLocationIcon from "./icons/ChangeLocationIcon";
import { LocationDto, MemberDto } from "../generated/dashboard-client";
import { env } from "../env/env";
import { useMemo, useRef, useState } from "react";

interface AppAsideProps {
  location: LocationDto;
  users: MemberDto[];
}

export default function LocationDropdown({ location, users }: AppAsideProps) {
  const navigate = useNavigate();
  const [locations] = useRecoilState(locationsState);
  const [member] = useRecoilState(memberState);
  const dropdownButton = useRef<HTMLButtonElement>(null);
  const [searchQuery, setSearchQuery] = useState("");

  const filteredLocations = useMemo(() => {
    if (!searchQuery.trim()) return locations;
    const q = searchQuery.toLowerCase().trim();
    return locations.filter(
      (loc) =>
        loc.name?.toLowerCase().includes(q) ||
        loc.address?.toLowerCase().includes(q) ||
        loc.city?.toLowerCase().includes(q) ||
        loc.state?.toLowerCase().includes(q)
    );
  }, [locations, searchQuery]);

  function goToLocations() {
    console.log(users.length);
    navigate(`${env.dashboardPath}/account/locations`);
  }

  function goToLocation(loc: LocationDto) {
    if (loc.internalId === location.internalId) return;
    let path = window.location.pathname;
    if (path.includes("link-pages")) {
      navigate(`${env.dashboardPath}/link-pages/${loc.internalId}`);
    } else if (path.includes("brand")) {
      navigate(`${env.dashboardPath}/brand/${loc.internalId}`);
    } else {
      navigate(`${env.dashboardPath}/designs/${loc.internalId}`);
    }
    dropdownButton.current?.click();
  }

  const menu = (
    <div className={"loc-drop-menu"}>
      <h6>Switch to another location</h6>
      {locations.length > 5 && (
        <Input
          type="search"
          prefix={<SearchOutlined />}
          placeholder="Search for a location"
          value={searchQuery}
          onChange={(ev) => setSearchQuery(ev.target.value)}
          className="loc-drop-search"
          allowClear
        />
      )}
      <ul>
        {filteredLocations.map((it) => (
          <li key={it.id} className={it.internalId === location.internalId ? "selected" : ""}>
            <div className={"lk"} onClick={() => goToLocation(it)}>
              <h6>{it.name}</h6>
              <p>
                {it.address}
                {it.city !== "" && (
                  <span>
                    <br />
                    {it.city}
                  </span>
                )}
                {it.state !== "" && <span>, {it.state}</span>}
              </p>
              <div className="user-count">
                <UserOutlined />
                {it.managersCount} {it.managersCount === 1 ? "user" : "users"}
              </div>
            </div>
          </li>
        ))}
        {searchQuery.trim() && filteredLocations.length === 0 && (
          <li className="loc-drop-empty">
            <p>No locations found</p>
          </li>
        )}
      </ul>
      {member.owner && <footer>
        <Button className={"secondary-two"} onClick={goToLocations}>
          Manage Locations
        </Button>
      </footer>}
    </div>
  );

  return <>
    <Dropdown
      className={"loc-drop"}
      overlay={menu}
      getPopupContainer={(trigger) => trigger.parentNode as HTMLElement}
      trigger={["click"]}
      onVisibleChange={(visible) => {
        if (!visible) setTimeout(() => setSearchQuery(""), 500);
      }}
    >
      <Button type={"link"} size={"large"} onClick={(e) => e.preventDefault()} ref={dropdownButton}>
        <div className={"icn"}>
          <ChangeLocationIcon />
        </div>
        <div className={"txt"}>
          <p className="loc-name">{location?.name}</p>
          <p className="loc-addr">{location?.address}</p>
        </div>
        <DownOutlined className={"carr"} />
      </Button>
    </Dropdown>
  </>;
}
